import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0); // This will set the scroll position to the top
  }, [pathname]);

  return null;
};

export default ScrollToTop;

